import WisPriceListSelector from "components/shared/WisPriceListSelector";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { CustomerContext } from "./CustomerPage";

const PriceListView = () => {
  const { customer, save, saveRes } = useContext(CustomerContext);

  return (
    <div className="card">
      <h5>Price List</h5>
      <div className="opacity-70">
        Customer is only allowed to order products from this price list.
      </div>
      <div className="mt-2 space-y-2">
        <div className="-mx-[2px] flex items-center space-x-2">
          <WisPriceListSelector
            value={customer.priceList?.id}
            onChange={(value) => {
              let variables = { id: customer.id };
              if (value) {
                variables.priceListId = value.id;
              } else {
                variables.removeFields = ["price_list"];
              }
              save({ variables });
            }}
            disabled={saveRes.loading}
          />

          {customer.priceList && (
            <Link
              to={`/sales/price-lists/${customer.priceList?.id}`}
              target="_blank"
            >
              View
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default PriceListView;
